import React, { useState, useEffect } from "react";
import useVisible from "../../hooks/useVisible.jsx";
import getFonts from "../../utils/buttons/getFonts";
import fixExportMogrt from "../../utils/buttons/fixExportMogrt";
import getFootages from "../../utils/buttons/getFootages";
import { getCachedScript } from "../../utils/scriptCache.js";
import handleClick from "../../utils/handleClick.js";

function ExportMogrt({
  onPopupStateChange,
  selectedTag,
  buttonTags,
  generateButtonTags,
}) {
  const [isVisible, setIsVisible] = useVisible("ExportMogrtVisibility");
  const [type, setType] = useState("mg");
  const [format, setFormat] = useState("txt");

  useEffect(() => {
    localStorage.setItem("ExportMogrtFormat", format);
  }, [format]); // Эффект отслеживает изменения format

  // Функция для переключения между 'rtf' и 'txt'
  const toggleFormat = () => {
    setFormat((currentFormat) => (currentFormat === "rtf" ? "txt" : "rtf"));
  };

  useEffect(() => {
    if (onPopupStateChange) {
      onPopupStateChange(isVisible);
    }
  }, [isVisible]);

  // Убедитесь, что zipTemplate правильно обрабатывает и возвращает Promise

  // const handleClick = async (
  //   adobeStock,
  // ) => {
  //   const code = getCachedScript();
  //   if (code) {
  //     try {
  //       const result = await fixExportMogrt(
  //         adobeStock,
  //       );
  //     } catch (error) {
  //       //alert(error); // Обработка ошибки
  //     }
  //   }
  // };

  const handleHelp = (script, argument) => {
    const code = getCachedScript();
    if (code) {
      window.jsx.evalScript(
        `run(${script}(${argument}));`,
        function (result) {},
      );
    }
  };

  if (selectedTag && !buttonTags.includes(selectedTag)) {
    return null;
  }

  return (
    <>
      <li
        onClick={() => setIsVisible(!isVisible)}
        className={`button-card resolution-toggle ${isVisible ? "active" : ""}`}
      >
        <div className="button-card__icon">
          <i class="fa-regular fa-download"></i>
        </div>
        <div className="button-card__title">Export Mogrt</div>
        {generateButtonTags()}
      </li>
      <div
        className={`render-group ${isVisible ? "" : "render-group--hidden"}`}
      >
        <div className="render-group__tools-grid">
          <div
            onClick={() => handleClick("exportMogrt", { adobeStock: false })}
            className="resolution-tools__button"
          >
            <i class="fa-regular fa-download"></i>
            <span>Export</span>
          </div>
          <div
            onClick={() => handleHelp("createHelpMA", JSON.stringify(type))}
            className="resolution-tools__button"
          >
            <i class="fa-sharp fa-light fa-file-pdf"></i>
            <span>Help PDF</span>
          </div>
          <div
            onClick={() => getFonts(false, true, format, type, "google")}
            className="resolution-tools__button"
          >
            <i class="fa-brands fa-google"></i>
            <span>Google Fonts</span>
          </div>
          <div
            onClick={() => getFonts(false, true, format, type, "adobe")}
            className="resolution-tools__button"
          >
            <i class="fa-regular fa-font"></i>
            <span>Adobe Fonts</span>
          </div>
          <div
            onClick={() => getFootages(format, type)}
            className="resolution-tools__button"
          >
            <i class="fa-regular fa-image"></i>
            <span>Footage Links</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default ExportMogrt;
